import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/header+footer/Header.css';
import blueGuy from '../../assets/images/Heroes/BlueGuy.svg';
// import heroicIcon from '../../assets/images/icons/packages/heroic-icon.png';
// import povertyIcon from '../../assets/images/icons/packages/poverty-icon.png';
// import portalIcon from '../../assets/images/icons/packages/portal-icon.png';
import eduheroPlainLogo from '../../assets/images/Titles/eduhero-plain-logo.svg';
// import region6 from '../../assets/images/icons/regions/region6.png';
import eduheroShieldH from '../../assets/images/icons/eduhero/eduheroShieldH.svg';
import Search from './Search';
import AccountInfo from './AccountInfo';
import stateToggler from '../../helpers/stateToggler';
import { useAuth } from '../../contexts/session';
import { useApi } from '../../hooks/useApi';


const Header = () => {
    const { fetchGet, fetchPost } = useApi();

    const [controlPanel, setControlPanel] = useState(false);
    // const [account, setAccount] = useState(false);
    const [accountInfo, setAccountInfo] = useState(false);
    const { userObj, isLoading, refreshAccessToken, logout } = useAuth();

    const focusOnSearch = () => {
        if(window.innerWidth <= 1100){
            document.getElementById("headerSearchMobile").focus();
        } else {
            document.getElementById("headerSearch").focus();
        }
    };

    // if click isnt on the control panel grouping
    const offElClick = useCallback((e) => {
        e.stopPropagation();
        
        // const mobileMenuButton = document.getElementById("mobileMenuButton").contains(e.target);

        // if(controlPanel && !cp && !headerSearch && !headerSearchMag && !headerSearchCancel && !headerSearchMobileMag) {
        if(controlPanel) {
            const nineDots = document.getElementById("nineDots").contains(e.target);
            let cp = document.getElementById("cp");
            let headerSearchEl = document.getElementById("headerSearch");
            // const headerSearchIcon = document.getElementById("headerSearchMag").contains(e.target) || document.getElementById("headerSearchCancel").contains(e.target) || document.getElementById("headerSearchMobileMag").contains(e.target);
            let headerSearchMagEl = document.getElementById("headerSearchMag");
            let headerSearchCancelEl = document.getElementById("headerSearchCancel");
            let headerSearchMobileMagEl = document.getElementById("headerSearchMobileMag");

            if(cp) {
                cp = cp.contains(e.target);
            }

            if(headerSearchEl){
                headerSearchEl = headerSearchEl.contains(e.target);
            }

            if(headerSearchMagEl){
                headerSearchMagEl = headerSearchMagEl.contains(e.target);
            }

            if(headerSearchCancelEl){
                headerSearchCancelEl = headerSearchCancelEl.contains(e.target);
            }

            if(headerSearchMobileMagEl){
                if(headerSearchMobileMagEl.id === e.target.id){
                    headerSearchMobileMagEl = true;
                } 
                else{
                    headerSearchMobileMagEl = false;
                } 
            }
            
            if(!nineDots && !cp && !headerSearchEl && !headerSearchMagEl && !headerSearchCancelEl && !headerSearchMobileMagEl) {                
                setControlPanel(false);
            }
        }

        if(accountInfo){
            let mobileAccountInfo = document.getElementById("accountInfo");
            const avatar = document.getElementById("avatar").contains(e.target);

            if(mobileAccountInfo){
                mobileAccountInfo = mobileAccountInfo.contains(e.target);
            }
            if(!mobileAccountInfo && !avatar && e.target.id !== "accountInfoSave" && e.target.id !== "accountInfoEdit" && e.target.id !== "accountInfoCancel"){
                setAccountInfo(false);
            }
        }
    }, [controlPanel, accountInfo]);

    
    // set up categories and account
    useEffect(() => {
        // set up account info

        // const safeUserData = JSON.parse(localStorage.getItem("safeUserData"));
        // if(safeUserData){
        //     setuserObj(safeUserData);
        // }

        // // get user data
        // fetchGet(`/routes/api/sessions/validateUserData/`)
        // .then(data => {
        //     if(data.type === "error"){
        //         console.log(data.message);
        //         return;
        //     }

        //     setuserObj(data.data);
            
        // });
        
        // fetchPost(`/routes/api/users/single/`, {user_id: 101})
        // .then(data => {
        //     if(data.type === "error"){
        //         console.log(data.message);
        //         return;
        //     }
        // });

    }, [])

    // handles Account bubble, menu, and arrow
    useEffect(() => {
        if(controlPanel){
            focusOnSearch();
            document.addEventListener("click", offElClick);
        }
        return () => {
            document.removeEventListener("click", offElClick);
        }
    }, [controlPanel])

    useEffect(() => {
        let accountArrow = document.getElementById("accountArrow");

        if(!accountInfo){
            accountArrow.style.transform = "rotate(180deg)";
        }
        else{
            accountArrow.style.transform = "rotate(0deg)";
            document.addEventListener("click", offElClick);
        }
        
        return () => {
            document.removeEventListener("click", offElClick);
        }
    }, [accountInfo]);


    return(
        <header id='header' className={"flex flexColumn flexCenter " + ((controlPanel || accountInfo) ? "headerAttach" : "")}>
            <section id='nav' className='flex flexJustifySpaceBetween' >
                <section className='navigationTile flex flexJustifyStart flexAlignCenter'>
                   
                    {/* <div className='mobileMenuButtonContainer'>
                        <div id="mobileMenuButton" className='mobileMenuButton flex flexColumn flexJustifyCenter' onClick={() => {mobileCP ? setMobileCP(false) : setMobileCP(true)}}>
                            <div id="tl" className='topLine'></div>
                            <div id="ml" className='midLine'></div>
                            <div id="bl" className='botLine'></div>
                        </div>
                    </div> */}
                    <Link to="/client/home" className='eduheroShieldHWrapper flex flexCenter'>
                        <img alt='Eduhero logo' className="eduheroShieldH" src={eduheroShieldH} />
                    </Link>
                    <Link to="/client/home" className='headerEduheroLogoWrapper flex flexCenter'>
                        <img alt='Eduhero logo' className="headerEduheroLogo" src={eduheroPlainLogo} />
                    </Link>
                    {/* <Link to="/client/home" className='portalLogoWrapper flex flexCenter'>
                        <img alt='Portal logo' className="portalLogo" src={region6} />
                    </Link> */}
                    
                    <div id="nineDots" className={"nineDots " + (controlPanel ? "fillerDotsX" : "")} onClick={() => controlPanel ? setControlPanel(false) : setControlPanel(true)} onKeyUp={() => setControlPanel(true)} onKeyDown={() => setControlPanel(false)} tabIndex={0}>
                        {/* nineDots shadow clones start */}
                        <div className={"cornerDots nineDotsShadow " + (controlPanel ? "fillerDotsX" : "")}>
                            <div className="nineDotsDot topLeftDot"></div>
                            <div className="nineDotsDot topRightDot"></div>
                            <div className="nineDotsDot bottomLeftDot"></div>
                            <div className="nineDotsDot bottomRightDot"></div>
                            <div className="nineDotsDot centerDot"></div>
                            <div className="nineDotsDot centerDot2"></div>
                        </div>
                        <div className={"fillerDots nineDotsShadow " + (controlPanel ? "fillerDotsX" : "")}>
                            <div className="nineDotsDot topCenterDot"></div>
                            <div className="nineDotsDot bottomCenterDot"></div>
                            <div className="nineDotsDot leftDot"></div>
                            <div className="nineDotsDot rightDot"></div>
                        </div>
                        {/* nineDots shadow clones end */}

                        <div className="cornerDots">
                            <div className="nineDotsDot topLeftDot"></div>
                            <div className="nineDotsDot topRightDot"></div>
                            <div className="nineDotsDot bottomLeftDot"></div>
                            <div className="nineDotsDot bottomRightDot"></div>
                            <div className="nineDotsDot centerDot"></div>
                            <div className="nineDotsDot centerDot2"></div>
                        </div>
                        <div className="fillerDots ">
                            <div className="nineDotsDot topCenterDot"></div>
                            <div className="nineDotsDot bottomCenterDot"></div>
                            <div className="nineDotsDot leftDot"></div>
                            <div className="nineDotsDot rightDot"></div>
                        </div>
                    </div>

                    <Search focusOnSearch={focusOnSearch} setControlPanel={setControlPanel} controlPanel={controlPanel} />
                </section>
                <section id='accountTile' className='accountTile flex flexJustifyEnd flexAlignCenter'>
                    <div className='accountInfo flex flexColumn flexJustifySpaceBetween flexAlignEnd'>
                        {/* {console.log(userObj)} */}
                        <p 
                            className='headerAccountInfoName'  
                            onClick={(e) => {
                                e.stopPropagation()
                                userObj?.account_setup_complete && stateToggler(accountInfo, setAccountInfo)}}
                        >
                            {
                                (userObj?.first_name && !isLoading) ? userObj.first_name : "---" 
                            }
                            {
                                ", "+((userObj?.last_name && !isLoading) ? userObj.last_name : " ---")
                            }
                            <span className='spanGray' title={userObj?.permission_names?.join(", ")}>
                                {   (userObj?.permission_names?.length && !userObj?.permission_names?.includes("User")) ?
                                    <>
                                        (
                                            {
                                                (userObj.permission_names[0].length > 8) ? 
                                                    userObj.permission_names[0].slice(0, 5)+"..."
                                                : 
                                                    userObj.permission_names[0]
                                            }
                                            {
                                                (userObj.permission_names.length > 1) ? 
                                                    ("+"+(userObj.permission_names.length-1)) 
                                                : 
                                                    ""
                                            }
                                        )
                                    </>
                                    :
                                    ""
                                }
                            </span>
                        </p>
                        {/* <div className="packageIconContainer flex flexJustifyEnd flexAlignCenter">
                            <img src={heroicIcon} alt="Heroic package icon" />
                            <img src={povertyIcon} alt="Framework for understanding poverty package icon" />
                            <img src={portalIcon} alt="Custom portal package icon" />
                        </div> */}
                        <button type='button' className="logout" onClick={logout}>LOGOUT</button>
                        </div>
                    <div className='avatarImgContainer' onClick={() => (userObj?.account_setup_complete ? stateToggler(accountInfo, setAccountInfo) : false)}>
                        <img src={blueGuy} id="avatar" alt="avatar" />
                    </div>
                    <div id='accountArrow' className={"accountArrow " + (userObj?.account_setup_complete ? "" : "hide" )}></div>
                    

                    {/* <div className='flex flexCenter gearIconWrapper'>
                        <i class="fa fa-gear gearIcon flex flexCenter"></i>
                    </div> */}
                    <AccountInfo refreshAccessToken={refreshAccessToken} accountInfo={accountInfo} userObj={userObj} avatar={blueGuy} logout={logout} />
                </section>
            </section>
            
            
            {/* <aside id='mobileMenu' className='mobileMenuContainer'>
                <div id='mobileMenuLinkContainer'>
                    <div></div>
                </div>
                <div className='controlPanelGuideContainer flex flexCenter' id='controlPanelGuideContainer'>
                    <Link to="./" className='flex flexColumn flexCenter' >
                        <h3>DOWNLOAD OUR APP</h3>
                    </Link>
                    <Link to="./" className='flex flexColumn flexCenter'>
                        <h3>NEED HELP WITH THESE TOOLS?</h3>
                    </Link>
                </div>
            </aside> */}

        </header>
    );
};

export default Header;